import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { ParkingGateCode } from "models";

const component = "ParkingGateCodesDashboard";

export const ParkingGateCodesDashboardQueryKeys = {
  parkingGateCodes: backendQueryKey<ParkingGateCode[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/parking_gate/code/list" })
};
